import { AcronymSearch } from "../../../../src/data/articles/regular-expressions/AcronymSearch.tsx";
import * as React from 'react';
export default {
  AcronymSearch,
  React
};